var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcAudits(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 22,
    viewBox: "0 0 19 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M9.5 0c1.307 0 2.422.8 2.909 1.928l.068.172h4.412c1.11 0 2.028.865 2.106 1.95L19 4.2v15.7c0 1.105-.87 2.017-1.96 2.095l-.151.005H2.11c-1.11 0-2.028-.865-2.106-1.95L0 19.9V4.2c0-1.105.87-2.017 1.96-2.095l.151-.005h4.412C6.967.882 8.128 0 9.5 0zM5 5.727H2v13.364h15v-2.864h-1v1.91H3V6.681h2v-.955zm10 10.5H4v.955h11v-.955zm0-1.909H4v.955h11v-.955zm-.94-3.818L13 12.119l3.392 2.023 1.06-1.619L14.06 10.5zM7 12.41H4v.954h3v-.955zm2.5-6.683C7.567 5.727 6 7.223 6 9.068c0 1.845 1.567 3.341 3.5 3.341S13 10.913 13 9.07c0-1.846-1.567-3.342-3.5-3.342zm0 .955c1.38 0 2.5 1.068 2.5 2.386s-1.12 2.387-2.5 2.387S7 10.386 7 9.068s1.12-2.386 2.5-2.386zM5 10.5H4v.955h1V10.5zm12-4.773h-3v.954h2V10.5h1V5.727zM9.5 2.1c-.58 0-1.056.472-1.056 1.05 0 .578.475 1.05 1.056 1.05.58 0 1.056-.473 1.056-1.05 0-.578-.475-1.05-1.056-1.05z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAudits);
export default __webpack_public_path__ + "static/media/ic_audits.f735b49618b64fbbe3301fa7bec403c1.svg";
export { ForwardRef as ReactComponent };